const URL = "https://weak-gray-boa-gear.cyclic.app";
// const URL = "http://127.0.0.1:5000";


export default URL;